import {RepositoryPicker, type RepositoryPickerRepository} from '@github-ui/item-picker/RepositoryPicker'

export type CopilotRepositoryPickerProps = {
  isOpen: boolean
  anchorRef: React.RefObject<HTMLElement | null>
  topRepos: RepositoryPickerRepository[]
  onSelect: (repo: {id: string; name: string; owner: {login: string}}) => void
  onClose: () => void
}

export const CopilotRepositoryPicker = ({
  isOpen,
  anchorRef,
  topRepos,
  onSelect,
  onClose,
}: CopilotRepositoryPickerProps) => {
  return (
    <RepositoryPicker
      initialRepository={undefined}
      onSelect={repo => {
        if (repo?.owner && repo?.name) {
          onSelect({
            id: repo.id,
            name: repo.name,
            owner: {login: repo.owner.login},
          })
        }
      }}
      topRepositories={topRepos}
      anchorElement={props => {
        const {ref} = props as React.HTMLAttributes<HTMLButtonElement> & {
          ref: React.RefObject<HTMLButtonElement | null>
        }
        if (ref) {
          ref.current = anchorRef.current as HTMLButtonElement | null
        }
        return <></>
      }}
      preventDefault
      title="Select a repository"
      subtitle="Start a codespace with Copilot agent mode for this issue in another repository."
      triggerOpen={isOpen}
      onClose={onClose}
    />
  )
}
